import React from 'react';
import { observer } from '../../shared/observer';
import { curFormat } from '../../shared/format';
import { minOrderCount, maxOrderCount, isFirstOrderUsed } from '../../shared/orderCount';

class CartItemRowView extends React.Component {
  inc = () => {
    const it = this.props.item;
    // потолок по складу (warehouse_count из модели товара), как handleIncrease в мобилке
    if (it.quantity >= maxOrderCount(it.model) || isFirstOrderUsed(it)) return;
    this.props.cart.addProductToCart({ item_id: it.item_id, quantity: it.quantity + 1, topping_ids: it.topping_ids });
  };
  dec = () => {
    const it = this.props.item;
    // минимальное количество берём из модели товара (ItemV3Serializer)
    const next = it.quantity - 1;
    if (next < minOrderCount(it.model)) { this.remove(); return; }
    this.props.cart.addProductToCart({ item_id: it.item_id, quantity: next, topping_ids: it.topping_ids });
  };
  remove = () => {
    const it = this.props.item;
    // откат при ошибке делает стор; reject глушим от unhandled rejection
    this.props.cart.removeProductFromCart(it.item_id, it.topping_ids).catch(() => {});
  };

  render() {
    const it = this.props.item;
    const auth = this.props.auth;
    const cur = (auth.companyInfo.currency_hash && auth.companyInfo.currency_hash.symbol_html) || '';
    const lineSum = (it.price || 0) * (it.quantity || 0);
    // «+» гаснет на потолке склада — иначе клик выглядит рабочим, но молча ничего не делает
    const atMax = it.quantity >= maxOrderCount(it.model) || isFirstOrderUsed(it);
    return (
      <div className="ng-cart-row">
        <div className="ng-cart-row__icon ng-img-box ng-img-box--sm">
          {it.icon_url ? (
            <img className="ng-img" src={it.icon_url} alt={it.title} />
          ) : (
            <span className="ng-cart-row__icon-placeholder" aria-hidden="true" />
          )}
        </div>
        <div className="ng-cart-row__main">
          <div className="ng-cart-row__title">{it.title}</div>
          {/* «Доставка сегодня» (company.show_delivery_term_tags): сервер кладёт delivery_term только таким строкам */}
          {it.delivery_term && it.delivery_term.label && (
            <div><span className="item-delivery-term item-delivery-term--today">{it.delivery_term.label}</span></div>
          )}
          {it.choosen_toppings && it.choosen_toppings.length > 0 && (
            <div className="ng-cart-row__toppings">
              {it.choosen_toppings.map((t) => t.title).join(', ')}
            </div>
          )}
          {isFirstOrderUsed(it) && <div className="ng-field-error">Только для первого заказа</div>}
          <div className="ng-cart-row__price">{curFormat(it.price)} {cur}</div>
        </div>
        <div className="ng-cart-row__qty">
          <span className="item-show-price-incart__wrapper">
            <a href="#" className="down" onClick={(e) => { e.preventDefault(); this.dec(); }}>−</a>
            <span className="item-show-price-incart__count">{it.quantity}</span>
            <a href="#" className={'up' + (atMax ? ' is-disabled' : '')} aria-disabled={atMax ? 'true' : null} onClick={(e) => { e.preventDefault(); this.inc(); }}>+</a>
          </span>
        </div>
        <div className="ng-cart-row__sum">{curFormat(lineSum)} {cur}</div>
        <button type="button" className="ng-cart-row__remove" onClick={this.remove} title="Удалить">×</button>
      </div>
    );
  }
}

export const CartItemRow = observer(CartItemRowView, ['cartStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/CartItemRow.jsx